module.exports = __webpack_public_path__ + "static/media/q_of_hearts2.6ca4a741.png";